// actionTypes.js
//export const LOAD_JOYRIDE_STEPS = 'LOAD_JOYRIDE_STEPS';
//export const SET_CURRENT_STEPS = 'SET_CURRENT_STEPS';

// userGuideActionTypes.js
export const LOAD_JOYRIDE_STEPS = "LOAD_JOYRIDE_STEPS";
export const SET_CURRENT_STEPS = "SET_CURRENT_STEPS";
export const START_TOUR = "START_TOUR";
export const STOP_TOUR = "STOP_TOUR";
export const NEXT_STEP = "NEXT_STEP";
export const SET_TOUR_STATE = "SET_TOUR_STATE";
